import React from 'react'
import i18n from 'live/services/i18n'
import { NavBarContainer } from './styles'

export type INavBarTab = {
    name: string
    disabled?: boolean
    hidden?: boolean
}

interface IProps {
    tabs: INavBarTab[]
    activeTabName: string
    handleTabClick: (tabName: string) => void
}

export const NavBar: React.FC<IProps> = ({ tabs, activeTabName, handleTabClick }) => {
    return (
        <NavBarContainer>
            <div className="navbar-header">
                {tabs?.map(el => {
                    return (
                        <div
                            className={`navbar-header-item custom-nav-bar-${el.name}
              ${activeTabName === el.name ? 'active' : ''}
               ${el.disabled ? 'disabled' : ''}
                ${el.hidden ? 'hidden' : ''}`}
                            onClick={() => handleTabClick(el.name)}
                        >
                            {i18n(el.name)}
                        </div>
                    )
                })}
            </div>
        </NavBarContainer>
    )
}
